export default __webpack_public_path__ + "static/media/Google.3c21c089.svg";